import { status, E99Constants } from '../Constants';

export function E99Users(state = {}, action: any) {
    switch (action.type) {
        case E99Constants.SEARCH_E99_REQUEST:
            return {
                ...state,
                search_outbound_status: status.IN_PROGRESS,
                searchOutBoundList: action.data
            };
        case E99Constants.SEARCH_E99_SUCCESS:
            return {
                ...state,
                search_outbound_status: status.SUCCESS,
                searchOutBoundList: action.data
            };
        case E99Constants.SEARCH_E99_FAILURE:
            return {
                ...state,
                search_outbound_status: status.FAILURE,
                searchOutBoundList: null
            };
        default:
            return state;
    }
}